import { render, staticRenderFns } from "./vehicleDisassembly.vue?vue&type=template&id=3afee32c&scoped=true"
import script from "./vehicleDisassembly.vue?vue&type=script&lang=js"
export * from "./vehicleDisassembly.vue?vue&type=script&lang=js"
import style0 from "./vehicleDisassembly.vue?vue&type=style&index=0&id=3afee32c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afee32c",
  null
  
)

export default component.exports